import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const EpcCustomerSkeleton = () => {
  return (
    <div className="p-4  ">
      {/* Item Cards Skeleton */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 mt-6">
        {[...Array(6)].map((_, index) => (
          <div
            key={index}
            className="bg-gray-50 border border-gray-300 shadow-sm rounded-lg px-4 py-3 text-center flex flex-col items-center"
          >
            <Skeleton width={60} height={15} />
            <Skeleton width={40} height={10} className="mt-2" />
          </div>
        ))}
      </div>

      <div className="space-y-4">
        {[...Array(5)].map((_, index) => (
          <div
            key={index}
            className="p-4 bg-white shadow-md rounded-lg flex items-center gap-4"
          >
            {/* Avatar Skeleton */}
            <Skeleton circle width={50} height={50} />

            {/* Customer Details Skeleton */}
            <div className="flex-1">
              <Skeleton height={20} width="50%" />
              <Skeleton height={15} width="80%" className="mt-2" />
            </div>

            {/* Action Buttons Skeleton */}
            <Skeleton width={30} height={30} />
            <Skeleton width={30} height={30} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default EpcCustomerSkeleton;
